import { TInvoice } from './types'

export function getInvoiceType(invoice: TInvoice): 'beam' | 'nonprofit' {
  if (invoice.type === 'quarterly') return 'nonprofit'
  return 'beam'
}
